var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from "vue-property-decorator";
import SvgIcon from "~/components/common/svg-icon.vue";
var CommonTitle = /** @class */ (function (_super) {
    __extends(CommonTitle, _super);
    function CommonTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: "标题" })
    ], CommonTitle.prototype, "title", void 0);
    __decorate([
        Prop({
            default: 'kaihuxinxi'
        })
    ], CommonTitle.prototype, "iconName", void 0);
    __decorate([
        Prop({
            default: 14
        })
    ], CommonTitle.prototype, "iconSize", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], CommonTitle.prototype, "showIcon", void 0);
    CommonTitle = __decorate([
        Component({
            components: {
                SvgIcon: SvgIcon
            }
        })
    ], CommonTitle);
    return CommonTitle;
}(Vue));
export default CommonTitle;
